<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          Spending Tolerance Configuration
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            Config Spending Tolerance
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon @click="getData">refresh</v-icon>
          </v-flex>
          <v-flex xs4 class="my-5">
            <v-text-field
              id="search"
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :must-sort="true"
            :loading="loading"
            :items-per-page="5"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 15, 25]
            }"
          >
            <v-progress-linear
              slot="progress"
              color="primary"
              indeterminate
            ></v-progress-linear>
            <template v-slot:item.spendingTolerance="{ item }">
              {{
                item.spendingTolerance.id !== null
                  ? item.spendingTolerance.amount !== 0
                    ? idr(item.spendingTolerance.amount)
                    : item.spendingTolerance.amount
                  : '-'
              }}
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn icon :id="'btn-edit' + item.id" @click="editDialog(item)">
                <v-icon color="secondblue">mdi-square-edit-outline</v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <label>No data displayed</label>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="showDialog" id="showDialog" persistent max-width="450px">
      <v-card>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="confrimMessage" class="pa-0">
            <v-card-title class="primary white--text">
              <span class="pa-0">
                Update Spending Tolerance
              </span>
            </v-card-title>
            <v-card-text class="pt-5 pb-0">
              <v-flex xs12>
                <label class="darkblue--text">
                  <b>Amount (IDR)</b>
                </label>
                <v-currency-field
                  label="Amount"
                  v-model="item.spendingTolerance.amount"
                  class="mt-2"
                  @keyup.enter="save()"
                />
              </v-flex>
            </v-card-text>
            <v-card-actions class="pb-6 px-4">
              <v-spacer></v-spacer>
              <v-btn color="#bd1e19" dark @click="showDialog = false">
                Close
              </v-btn>
              <v-btn color="primary" dark type="submit">
                Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '../../../mixins/ACLMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin],
  data() {
    return {
      progressDialogLoading: true,
      loading: true,
      descending: true,
      sort: '',
      totalItems: 0,
      options: {
        itemsPerPage: 5
      },
      search: '',
      breadcrumbs: [
        {
          text: 'Configuration',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Spending Tolerance',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      timeout: null,
      item: {
        spendingTolerance: {
          amount: 0
        }
      },
      items: [],
      headers: [
        {
          text: 'Division',
          value: 'name',
          sortable: false
        },
        {
          text: 'Tolerance',
          value: 'spendingTolerance',
          sortable: false
        },
        {
          text: 'Updated At',
          value: 'updated_at',
          sortable: false
        },
        {
          text: 'Action',
          value: 'action',
          sortable: false
        }
      ],
      showDialog: false
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    editDialog(item) {
      this.item = this.copy(item);
      this.showDialog = true;
    },
    getData() {
      this.progressDialogLoading = true;
      this.loading = true;
      return this.$store
        .dispatch('configuration/getTolerance')
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    confrimMessage() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to update config Spending Tolerance?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.save();
        }
      });
    },
    save() {
      this.progressDialogLoading = true;
      this.loading = true;
      let params = {
        tolerances: [
          {
            division_id: this.item.spendingTolerance.division_id,
            amount: this.item.spendingTolerance.amount
          }
        ]
      };
      this.$store
        .dispatch('configuration/updateTolerance', params)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.showDialog = false;
            Swal.fire('Success!', data.message.text_en, 'success');
            this.getData();
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    }
  }
};
</script>
